const BASE_URL = process.env.REACT_APP_BASE_URL
// 'http://localhost:5502';

export default BASE_URL;
